import React, { Component } from 'react'
import { get, lowerCase, startsWith } from 'lodash'

import Page from 'components/Page'
import FullWidthSection from 'components/FullWidthSection'
import { Row, Col, Container } from 'components/Layout'
import BlogPreview from 'features/Blog/BlogPreview'
import Footer from 'components/Footer'
import { Link } from 'react-router'
import IconClose from 'components/Icons/Close'

import cn from 'classnames'
import s from './BlogIndex.scss'
import colors from 'styles/colors-export.css'
import sText from 'components/Text/Text.scss'
import sAnim from 'components/Animation/Animation.scss'
import sLay from 'styles/modules/layout.scss'

export default class BlogIndex extends Component {
  componentWillMount() {
    const { getArticles } = this.props
    getArticles()
  }

  render() {
    const { articles, authors, categories, location, showBlogFilterModal } = this.props
    const searchTerm = lowerCase(location.query.searchTerm)
    const author = location.query.author
    const category = location.query.category

    const articlesFiltered = articles.filter(article => {
      const articleTitle = lowerCase(get(article, 'fields.title'))
      const authorDeets = get(article, 'fields.author.fields', {})
      const categoryDeets = get(article, 'fields.categories', [])

      const hasSearchTerm = searchTerm ? articleTitle.includes(searchTerm) : true
      const hasAuthor = author ? authorDeets.name === author : true
      const hasCategory = category ? categoryDeets.find(cat => cat.fields.name === category) : true

      return hasAuthor && hasCategory && hasSearchTerm
    })

    const hasArticles = articles && articles.length > 0
    const articlesOrDummy = hasArticles ? articlesFiltered : [1, 2, 3, 4]

    const title = ['Pickle Blog']
    if (category) title.push(category)
    if (author) title.push(author)
    if (searchTerm) title.push(searchTerm)

    return (
      <Page
        layout={{ header: 'landing' }}
        title={title.join(' : ')}
        style={{ background: 'rgba(0, 0, 0, 0.03)' }}
        description={`Upcoming features, guides, tips and more. | ${title.join(' : ')}`}
      >
        <FullWidthSection
          className={s.heading}
          fullHeight
          style={{ color: 'white', background: colors.primary }}
        >
          <div>
            <h2 className={cn(sText.heading5, sText.accent)}>The Pickle Blog</h2>
            <br />
            <div className={sText.divider} />
            <h1 className={sText.heading1}>News, features, tips and more.</h1>
            <div className={cn(sLay['layout-row'], s['filter-row'])}>
              {searchTerm && (
                <Link
                  className={s.tag}
                  to={{ pathname: location.pathname, query: { author, category } }}
                >
                  {searchTerm}
                  <IconClose />
                </Link>
              )}
              {author && (
                <Link
                  className={s.tag}
                  to={{ pathname: location.pathname, query: { searchTerm, category } }}
                >
                  {author}
                  <IconClose />
                </Link>
              )}
              {category && (
                <Link
                  className={s.tag}
                  to={{ pathname: location.pathname, query: { searchTerm, author } }}
                >
                  {category}
                  <IconClose />
                </Link>
              )}
              <a
                onClick={() =>
                  showBlogFilterModal({
                    searchTerm,
                    category,
                    categories,
                    author,
                    authors,
                    location,
                  })
                }
                className={cn(s.tag, s.add)}
                title="Filter Articles"
              >
                <IconClose style={{ transform: 'rotate(45deg)' }} />
              </a>
            </div>
          </div>
        </FullWidthSection>
        <Container
          className={cn(s.content, sAnim.comeUp, {
            [s.negativeMargin]: articlesOrDummy && articlesOrDummy.length > 0,
          })}
          paddingTop
          paddingBottom
        >
          <Row className={cn(sLay['layout-row'], sLay['layout-wrap'])}>
            {articlesOrDummy.map((article, idx) => (
              <Col
                key={(article.fields && article.fields.slug) || idx}
                className={
                  idx % 4 === 0
                    ? cn(sLay['flex-100'], s.item)
                    : cn(
                        sLay['flex-gt-md-33'],
                        sLay['flex-md-50'],
                        sLay['flex-sm-100'],
                        sLay['flex-xs-100'],
                        s.item
                      )
                }
              >
                <BlogPreview article={article} horizontal={idx % 4 === 0} location={location} />
              </Col>
            ))}
          </Row>
          {articlesOrDummy.length === 0 && <div className={sText.descrip3}>No results.</div>}
        </Container>
        <Footer white />
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogIndex/BlogIndex.jsx